import { useCallback } from 'react';
import { prop } from 'ramda';
import { get } from 'js/utils/fetch.util';
import { useAppSelector } from 'js/store/hooks';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { useComponentConfig, useComponentTranslations, useComponentMethods } from 'js/hooks/component';

import { IBannerFeed, IBannerConfig } from '../types';

export const useFetchBannerFeed = () => {
    const translate = useComponentTranslations();
    const { showComponentError } = useComponentMethods();
    const getCMSResourceURL = useGetCMSResourceURL();
    const requestStamp = useAppSelector(prop('requestStamp'));
    const { bannerFeedName } = <IBannerConfig>useComponentConfig();
    const bannerFeedURL = getCMSResourceURL(`/initialResources/bannerFeeds/${encodeURIComponent(bannerFeedName)}`, { t: requestStamp });

    return useCallback(async (): Promise<IBannerFeed> => {
        try {
            return await get(bannerFeedURL);
        } catch {
            showComponentError(translate('error'));

            throw new Error(`[Banner] unable to get banner feed "${bannerFeedName}"`);
        }
    }, [bannerFeedName, bannerFeedURL, translate, showComponentError]);
};
